import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from '../pages/Welcome/LoginPage';
import Dashboard from '../pages/Dashboard/Dashboard';
import NewIncomePage from '../pages/Income/NewIncomePage';
import ProtectedRoute from './ProtectedRoute';
import NewExpensePage from '../pages/Expenses/NewExpensePage';
import SupplierInvoicingPage from '../pages/Expenses/SupplierInvoicingPage';
import NewSupplierInvoicePage from '../pages/Expenses/NewSupplierInvoicePage';
import LedgerPage from '../pages/Transaction/LedgerPage';
import JournalPage from '../pages/Transaction/JournalPage';
import NewAssetPage from '../pages/Asset/NewAssetPage';
import NewLiabilityPage from '../pages/Liability/NewLiabilityPage';
import AccountsDashboard from '../pages/Accounts/AccountsDashboard';
import FinderPage from '../pages/FinderPage';
import AccountStatementPage from '../pages/Report/AccountStatementPage';
import ProfileSwitchPage from '../pages/ProfileSwitchPage';
import ConfigPage from '../pages/Config/ConfigPage';
import NewProfilePage from '../pages/Welcome/NewProfilePage';
import FinancialPeriodPage from '../pages/Report/FinancialPeriodPage';
import BankingPage from '../pages/Banking/BankingPage';
import SchoolFeesDashboard from '../pages/School/SchoolFeesDashboard';
import ManageStudentsPage from '../pages/School/ManageStudentsPage';
import PaySchoolFeesPage from '../pages/School/PaySchoolFeesPage';
import FeesTransactionsPage from '../pages/School/FeesTransactionsPage';
import StudentProfilePage from '../pages/School/StudentProfilePage';
import FeesDefaulterPage from '../pages/School/FeesDefaulterPage';
import ManageDiscountPage from '../pages/School/ManageDiscountPage';
import BillingCenterPage from '../pages/School/BillCenterPage';
import NewVendorPage from '../pages/Vendor/NewVendorPage';
import VendorListingPage from '../pages/Vendor/VendorListingPage';
import VendorProfilePage from '../pages/Vendor/VendorProfilePage';
import VendorStatementPage from '../pages/Vendor/VendorStatementPage';
import TrialBalancePage from '../pages/Report/TrialBalancePage';
import BalanceSheetPage from '../pages/Report/BalanceSheetPage';
import IncomeStatementPage from '../pages/Report/IncomeStatementPage';
import NewContraPage from '../pages/Asset/NewContraPage';
import AppreciateAssetPage from '../pages/Asset/AppreciateAssetPage';
import DepreciateAssetPage from '../pages/Asset/DepreciateAssetPage';
import SettleLiabilityPage from '../pages/Liability/SettleLiabilityPage';
import OnlineSchoolPaymentPage from '../pages/School/OnlineSchoolPaymentPage';
import SignUpPage from '../pages/Welcome/SignUpPage';
import AccountsChartTabularPage from '../pages/Accounts/AccountsChartTabularPage';
import { useConfig } from '../DataStore/ConfigContext';
import GymDesk from '../pages/Application/Gym/GymDesk';
import MemberFinderPage from '../pages/Application/Gym/MemberFinderPage';
import CustomerListingPage from '../pages/Application/Gym/CustomerListingPage';
import GymInvoiceHistoryPage from '../pages/Application/Gym/GymInvoiceHistoryPage';
import DailyCashFlowPage from '../pages/Report/DailyCashFlowPage';
import GymClassesPage from '../pages/Application/Gym/GymClassesPage';
import NewGeneralEntryPage from '../pages/Transaction/NewGeneralEntryPage';
import NoDataPage from '../pages/NoDataPage';
import MigrationAssistantPage from '../pages/Tools/MigrationAssistantPage';
import ForgotPasswordPage from '../pages/Welcome/ForgotPasswordPage';
import ResetPasswordPage from '../pages/Welcome/ResetPasswordPage';
import AssetLiabilityDashboard from '../pages/Dashboard/AssetLiabilityDashboard';
import FinanceDashboard from '../pages/Dashboard/FinanceDashboard';
import ProjectsPage from '../pages/Project/ProjectsPage';
import ProjectIncomeReportPage from '../pages/Report/ProjectIncomeReportPage';
import NoAccessPage from '../pages/NoAccessPage';
import NexumPayPage from '../pages/Banking/NexumPayPage';
import CheckingTransactionsPage from '../pages/Banking/CheckingTransactionsPage';
import FeesVotesPage from '../pages/School/FeesVotesPage';
import BillingBatchPage from '../pages/School/BillingBatchPage';
import CompanyResetPage from '../pages/Tools/CompanyResetPage';
import LedgerApprovalPage from '../pages/Transaction/LedgerApprovalPage';
import OpeningBalancesPage from '../pages/Report/OpeningBalancesPage';
import StudentWalletPage from '../pages/School/StudentWalletPage';
import StudentWalletBalancePage from '../pages/School/StudentWalletBalancePage';
import AdvanceFeesPage from '../pages/School/AdvanceFeesPage';
import TransactionLedgerDetailPage from '../pages/Transaction/TransactionLedgerDetailPage';


const SystemRoutes = () => {

  const {companyCode} = useConfig();

    return (
      <Router>
      <Routes>
        <Route path="/login" exact element={<LoginPage />} />
        <Route path="/forgot-password" exact element={<ForgotPasswordPage />} />
        <Route path="/reset-password" exact element={<ResetPasswordPage />} />
        <Route path="/access-denied" exact element={<NoAccessPage />} />

        <Route path="/signup" exact element={<SignUpPage />} />
        <Route path="/switch" element={<ProfileSwitchPage />} />
        <Route path="/profile-create" element={<NewProfilePage />} />
        <Route path="/" element={<ProtectedRoute element={FinanceDashboard} />} />
        <Route path="/dashboard" element={<ProtectedRoute element={FinanceDashboard} />} />
        <Route path="/analytics" element={<ProtectedRoute element={Dashboard} />} />
        <Route path="/projects" element={<ProtectedRoute element={ProjectsPage} />} />


        {companyCode === 'GYM' && <>
        <Route path="/gym" element={<ProtectedRoute element={GymDesk} />} />
        <Route path="/gym-customers" element={<ProtectedRoute element={CustomerListingPage} />} />
        <Route path="/gym-finder" element={<ProtectedRoute element={MemberFinderPage} />} />
        <Route path="/gym-invoices" element={<ProtectedRoute element={GymInvoiceHistoryPage} />} />
        <Route path="/gym-classes" element={<ProtectedRoute element={GymClassesPage} />} />

        </>}

        
        <Route path="/report-daily-cashflow" element={<ProtectedRoute element={DailyCashFlowPage} />} />


        {companyCode === 'SCHOOL' && <>
        <Route path="/school-fees-overview" element={<ProtectedRoute element={SchoolFeesDashboard} />} />
        <Route path="/school-fees-students" element={<ProtectedRoute element={ManageStudentsPage} />} />
        <Route path="/school-fees-new" element={<ProtectedRoute element={PaySchoolFeesPage} />} />
        <Route path="/school-fees-transactions" element={<ProtectedRoute element={FeesTransactionsPage} />} />
        <Route path="/school-fees-pstudent" element={<ProtectedRoute element={StudentProfilePage} />} />
        <Route path="/school-fees-wstudent" element={<ProtectedRoute element={StudentWalletPage} />} />
        <Route path="/school-fees-defaulters" element={<ProtectedRoute element={FeesDefaulterPage} />} />
        <Route path="/school-fees-discounts" element={<ProtectedRoute element={ManageDiscountPage} />} />
        <Route path="/school-fees-billing" element={<ProtectedRoute element={BillingCenterPage} />} />
        <Route path="/school-fees-online" element={<ProtectedRoute element={OnlineSchoolPaymentPage} />} />
        <Route path="/school-fees-votes" element={<ProtectedRoute element={FeesVotesPage} />} />
        <Route path="/school-fees-batch" element={<ProtectedRoute element={BillingBatchPage} />} />
        <Route path="/school-fees-wallet" element={<ProtectedRoute element={StudentWalletBalancePage} />} />
        <Route path="/school-fees-advances" element={<ProtectedRoute element={AdvanceFeesPage} />} />
        </>}

        <Route path="/expenses-new" element={<ProtectedRoute element = {NewExpensePage} permissionCode={['ENTRY_CREATE']}/>} />
        <Route path="/income-new" element={<ProtectedRoute element={ NewIncomePage } permissionCode={['ENTRY_CREATE']}/>} />
        <Route path="/expenses-invoicing" element={< ProtectedRoute element={SupplierInvoicingPage} />} />
        <Route path="/expenses-new-invoice" element={< ProtectedRoute element={NewSupplierInvoicePage} permissionCode={['ENTRY_CREATE']}/>} />
        <Route path="/transaction-ledger" element={< ProtectedRoute element={LedgerPage} />} />
        <Route path="/transaction-journal" element={< ProtectedRoute element={JournalPage} />} />
        <Route path="/transaction-journal-new" element={< ProtectedRoute element={NewGeneralEntryPage} />} />
        <Route path="/transaction-ledger/:ledgerGrouping" element={<ProtectedRoute element={TransactionLedgerDetailPage} />} />
        <Route path="/ledger-approval" element={< ProtectedRoute element={LedgerApprovalPage} permissionCode={['ENTRY_APPROVAL']}/>} />

        <Route path="/asset-new" element={<ProtectedRoute element={ NewAssetPage } />} permissionCode={['ENTRY_CREATE']}/>
        <Route path="/asset-contra-new" element={<ProtectedRoute element={ NewContraPage } permissionCode={['ENTRY_CREATE']}/>} />
        <Route path="/asset-appreciate" element={<ProtectedRoute element={ AppreciateAssetPage} permissionCode={['ENTRY_CREATE']}/>} />
        <Route path="/asset-depreciate" element={<ProtectedRoute element={ DepreciateAssetPage} permissionCode={['ENTRY_CREATE']}/>} />
        <Route path="/asset-dashboard" element={<ProtectedRoute element={ AssetLiabilityDashboard} />} />

        
        <Route path="/liability-new" element={<ProtectedRoute element={ NewLiabilityPage } permissionCode={['ENTRY_CREATE']}/>} />
        <Route path="/liability-new" element={<ProtectedRoute element={ NewLiabilityPage } permissionCode={['ENTRY_CREATE']}/>} />
        <Route path="/liability-pay" element={<ProtectedRoute element={ SettleLiabilityPage } permissionCode={['ENTRY_CREATE']}/>} />

        <Route path="/accounts-chart" element={<ProtectedRoute element={ AccountsDashboard } />} />
        <Route path="/accounts-chart-tab" element={<ProtectedRoute element={ AccountsChartTabularPage } />} />

        <Route path="/finder" element={<ProtectedRoute element={ FinderPage } />} />
        <Route path="/report-account-statement" element={<ProtectedRoute element={ AccountStatementPage } />} />
        <Route path="/report-financial-period" element={<ProtectedRoute element={ FinancialPeriodPage } permissionCode={['VIEW_REPORTS']}/>} />
        <Route path="/report-trial-balance" element={<ProtectedRoute element={ TrialBalancePage } permissionCode={['VIEW_REPORTS']} />} />
        <Route path="/report-balance-sheet" element={<ProtectedRoute element={ BalanceSheetPage } permissionCode={['VIEW_REPORTS']}/>} />
        <Route path="/report-income-statement" element={<ProtectedRoute element={ IncomeStatementPage } permissionCode={['VIEW_REPORTS']} />} />
        <Route path="/project-income-report/:id" element={<ProtectedRoute element={ ProjectIncomeReportPage } />} permissionCode={['VIEW_REPORTS']} />
        <Route path="/opening-balances" element={<ProtectedRoute element={ OpeningBalancesPage } permissionCode={['VIEW_REPORTS']} />} />

        <Route path="/banking" element={<ProtectedRoute element={ BankingPage } />} />
        <Route path="/banking-nexumpay" element={<ProtectedRoute element={ NexumPayPage } />} />
        <Route path="/banking-transactions" element={<ProtectedRoute element={ CheckingTransactionsPage } />} />


        <Route path="/settings" element={<ProtectedRoute element={ ConfigPage } permissionCode={['MANAGE_SETTINGS']}/>} />

        <Route path="/vendor-new" element={<ProtectedRoute element={ NewVendorPage } />} />
        <Route path="/vendor-list" element={<ProtectedRoute element={ VendorListingPage } />} />
        <Route path="/vendor-profile" element={<ProtectedRoute element={ VendorProfilePage } />} />
        <Route path="/vendor-statement" element={<ProtectedRoute element={ VendorStatementPage } />} />

        <Route path="/migration-assistant" element={<ProtectedRoute element={ MigrationAssistantPage } permissionCode={['MIGRATION_ASSISTANT']}/>} />
        <Route path="/migration-reset" element={<ProtectedRoute element={ CompanyResetPage } permissionCode={['MIGRATION_ASSISTANT']}/>} />



        {/* <Route component={NotFound} /> */}
        <Route path="*" exact element={<NoDataPage/>} />

      </Routes>
    </Router>
    );
};

export default SystemRoutes;